import React, {FC, memo } from 'react';
import styles from './styles.scss';

const UserAgreement: FC = () => {
	return (
		<div className={styles['user-agreement']}>
			<h1>AirClass用户注册协议</h1>
			<p className={styles['info']}>欢迎使用上海知身为信息网络科技有限公司及其关联公司（以下称“AirClass”或
“我们”）在线教育服务，在使用AirClass之前请您仔细阅读本用户协议。AirClass感谢您的支持和信任！</p>
			<p className={styles['info']}>AirClass提示您：阅读本协议的过程中，如果您不同意本协议或其中任何条款约
定，您应立即停止注册程序。如您未申请注册流程，您仍可浏览网站或APP或相关链接页面内容，但无法通过账号注册获得AirClass的课程服务。</p>
            <h4>如果您在本协议生效前已成为AirClass平台的注册用户，则您通过访问和/或使用AirClass平台网站、客户端（含APP/APK/SDK/API方式）、内容分发、信
息网络传播等方式在内的各种形态（包括未来技术发展出现新的服务形态），即视为您表示同意接受本协议的全部内容，否则请您不要访问或接受AirClass平台服务。</h4>
			<div className={styles['container']}>
				<h2 className={styles['title']}>一、注册协议条款的确认和接受</h2>
				<p className={styles['txt']}>本用户协议双方分别为“上海知身为信息网络科技有限公司及其关联公司（以下称“AirClass”或“我们”）和“AirClass的用户（含AirClass1on1、AirClasskids、AirClass在线教育等网站及软件的用户）”，本用户协议具有合同效力。</p>
				<p className={styles['txt']}>AirClass网站（www.air-class.com/www.airclasskids.com）(以下亦称“本网站”)同意按照本协议的规定及其不定时发布的操作规则提供基于互联网和移动网的相关服务(以下称“网络服务”)。</p>
				<p className={styles['txt']}>本协议为AirClass用户注册协议（以下称“《协议》”），为获得网络服务,申请人应当认真
阅读、充分理解本《协议》中各条款,包括免除或者限制AirClass责任的免责条款及对用户的权利限制条款。审慎阅读并选择接受或不接受本《协议》(未成年人应在法定监护人陪同
下阅读，并在提交个人信息之前寻求父母或监护人的同意和指导。)。同意接受本《协议》的全部条款的,申请人应当按照页面上的提示完成全部的注册程序,并在注册程序过程中点击“注册”按钮,否则视为不接受本《协议》全部条款,申请人应当终止并退出申请。</p>
				<p className={styles['txt']}>用户注册成功后，AirClass将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码
由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。用户注册成
功，AirClass将会向每位注册用户拨打电话进一步介绍本公司的相关服务情况。用户的注册
行为即视同为同意接受公司进一步的电话服务。</p>
				<p className={styles['txt']}>AirClass有权对用户使用AirClass网络服务的情况进行审查和监督(包括但不限于对用户存
储在AirClass的内容进行审核)，如用户在使用网络服务时违反任何上述规定，AirClass或
其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张
贴的内容等、暂停或终止用户使用网络服务的权利）以减轻用户不当行为造成的影响。</p>
				<p className={styles['txt']}>AirClass针对某些特定的AirClass网络服务的使用通过各种方式（包括但不限于网页公告、
电子邮件、短信提醒等）作出的任何声明、通知、警示等内容视为本《协议》的一部分，用户如使用该等AirClass网络服务，视为用户同意该等声明、通知、警示的内容。</p>
				<p className={styles['txt']}>本《协议》可由AirClass不定时更新，如本《协议》有任何变更，AirClass将在网站上刊载
公告，通知予用户。经修订的协议一经在AirClass官网公布后，立即自动生效。<b>在本网站修改《协议》条款后,如果用户不接受修改后的条款,请立即停止使用本网站提供的网络服务,继续使用的用户将被视为已接受了修改后的协议。</b></p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>二、定义</h2>
				<p className={styles['txt']}>用户及用户注册：用户必须是具备完全民事行为能力的自然人。用户注册是指用户登录
AirClass官网（www.air-class.com/www.airclasskids.com），并按要求填写相关信息并确认同批注[樊玲1]:待确认，应该要加上留学的域名意履行《协议》的过程。用户因进行交易、获取有偿服务所有应纳税赋，以及一切硬件、软件、服务及其它方面的费用均由用户负责支付。AirClass仅作为网络教育培训平台。</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>三、AirClass的权利和义务</h2>
				<p className={styles['txt']}>1、AirClass有义务在现有技术上维护整个网络教育平台的正常运行，并努力提升和改进技术，使用户网络教育活动得以顺利进行；</p>
				<p className={styles['txt']}>2、对用户在注册使用AirClass网络教育平台中所遇到的与交易或注册有关的问题及反映的情况，AirClass应及时作出回复；</p>
				<p className={styles['txt']}>3、对于用户在AirClass网络教育平台上的不当行为或其它任何AirClass认为应当终止服务的情况，AirClass有权随时作出删除相关信息、终止服务提供等处理，而无须征得用户的同意；AirClass应本着诚实信用的原则向用户提供远程教育服务，不得随意中断或停止提供该项服务。但由于不可抗力或者其它非人为因素造成的服务的中断或停止，AirClass不承担任何相应的责任。</p>
				<p className={styles['txt']}>4、AirClass享有对用户网上活动的监督和指导权，对凡是从事网上非法活动的用户，有权终止所有服务</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>四、用户的权利和义务</h2>
				<p className={styles['txt']}>1、所有用户必须遵循：</p>
				<p className={styles['txt']}>（1）遵守所有使用网络服务的网络协议、规定、程序和惯例；</p>
				<p className={styles['txt']}>（2）不得使用AirClass网络教育平台从事违法活动；</p>
				<p className={styles['txt']}>（3）不得干扰或侵犯AirClass的正常运行和其他用户的正常使用；</p>
				<p className={styles['txt']}>（4）用户购买的课程只允许个人使用，不能用于其他目的；</p>
				<p className={styles['txt']}>（5）从中国境内向境外传输技术性资料时不得违反中国有关法律、法规。</p>
				<p className={styles['txt']}>2、同时用户承诺</p>
				<p className={styles['txt']}>（1）不得利用AirClass在线网络教育平台制作、复制、查阅和传播下列信息：</p>
				<p className={styles['txt']}>任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的信息资料；</p>
				<p className={styles['txt']}>—任何教唆他人进行违法犯罪行为的资料；</p>
				<p className={styles['txt']}>—不利于国内团结和社会安定的资料；</p>
				<p className={styles['txt']}>—任何不符合国家法律、法规规定的资料、信息；</p>
				<p className={styles['txt']}>—任何捏造或者歪曲事实，散布谣言，扰乱社会秩序的信息；</p>
				<p className={styles['txt']}>—损害AirClass在线教育的声誉和商业利益的信息；</p>
				<p className={styles['txt']}>（2）不得未经许可而非法进入其它个人或组织电脑系统；</p>
				<p className={styles['txt']}>（3）未经允许，不得对AirClass在线网络教育平台中存储、处理或者传输的数据和应用程
序进行删除、修改或者增加；</p>
				<p className={styles['txt']}>（4）不得故意制作、传播计算机病毒等破坏性程序；</p>
				<p className={styles['txt']}>（5）法律规定的其他义务。</p>
				<p className={styles['txt']}>如果用户的行为违背上述两款规定，AirClass可以做出独立判断并有权立即取消用户资格。
用户应对自己在AirClass网络教育平台上的违法行为承担全部法律责任。</p>
				<p className={styles['txt']}>3、基于网络服务的特殊性，用户同意：</p>
				<p className={styles['txt']}>（1）在注册时按照注册提示提供准确用户名和密码以及联系方式；</p>
				<p className={styles['txt']}>（2）在个人的注册信息发生变化时，用户应及时更新自己的注册信息，保证其个人资料的
详尽和准确。所有用户输入的个人信息将被视作准确表明了用户的身份，并作为AirClass提供所有服务的有效身份依据。</p>
				<p className={styles['txt']}>（3）用户自行配备上网的所需设备，包括个人电脑、调制解调器或其他必备上网装置；</p>
				<p className={styles['txt']}>（4）用户应自行负担因使用这种接入方式而产生的上网电话费、上网信息费及教育信息费。</p>
				<p className={styles['txt']}>4、用户的用户名、密码。</p>
				<p className={styles['txt']}>（1）用户一旦注册成功，成为AirClass的正式用户后，应当对自己的用户名（亦称帐号）、
密码的安全性负全部责任。用户的密码只能由用户自己掌握。对于用户因帐号或密码泄露造成的各种损失，AirClass不承担任何责任。用户发现任何非法使用用户帐号的情况，应立即
通知本网站。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，AirClass不承担任何责任</p>
				<p className={styles['txt']}>（2）对于用户通过AirClass网络服务（包括但不限于论坛、BBS、教育问答）上传到AirClass
网站上可公开获取区域的任何内容，用户同意AirClass在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、
翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。</p>
				<p className={styles['txt']}>（3）确保您在每个上网时段结束时，以正确步骤离开网站/服务。</p>
				<p className={styles['txt']}>（4）AirClass不能也不会对因您未能遵守本款规定而发生的任何损失负责。用户应对以其用户名进行的所有活动和事件负责。</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>五、版权声明</h2>
				<p className={styles['txt']}>本网站提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护,未经相关权利人同意,上述资料均不得在任何媒体直接
或间接发布、播放、出于播放或发布目的而改写或再发行,或者被用于其他任何商业目的。所有以上资料或资料的任何部分仅可作为私人和非商业用途保存。<b>本网站不就由上述资料产
生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿,以任何形式,向用户或任何第三方负责。</b></p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>六、法律管辖</h2>
				<p className={styles['txt']}>1、本《协议》的订立、执行和解释及争议的解决均应适用中国法律并受中国法院管辖。</p>
				<p className={styles['txt']}>2、如双方就本《协议》内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成
时，任何一方均可向AirClass所在地的人民法院提起诉讼。</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>七、知识产权</h2>
				<p className={styles['txt']}>AirClass对AirClass专有内容、原创内容和其他通过授权取得的独占或独家内容享有完全知
识产权。未经AirClass许可，任何单位和个人不得私自转载、传播或者有其他侵犯AirClass知识产权的行为，否则将承担所有相关的法律责任。</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>八、协议的终止</h2>
				<p className={styles['txt']}>您有权通过以下方式终止本《协议》：</p>
				<p className={styles['txt']}>在履行完毕所有义务后注销账户，并向AirClass工作人员明示表示不愿继续使用相关平台服
务。</p>
			</div>
			<div className={styles['container']}>
				<h2 className={styles['title']}>九、其他规定</h2>
				<p className={styles['txt']}>1、本《协议》构成双方对本《协议》之约定事项及其他有关事宜的完整协议，除本《协议》
规定的之外，未赋予本《协议》各方其他权利。</p>
				<p className={styles['txt']}>2、如本《协议》中的任何条款无论因何种原因完全或部分无效或不具有执行力，本《协议》的其余条款仍应有效并且有约束力。</p>
				<p className={styles['txt']}>3、本《协议》中的标题仅为方便而设，在解释本《协议》时应被忽略。</p>
			</div>
			<h3>上海知身为信息网络科技有限公司及其关联公司</h3>
		</div>
	);
}
export default memo(UserAgreement);
